import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import DealerContact from '../../entities/admin/dealercontact'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'
import PageResult from '@/store/entities/page-result';

interface DealerContactState extends ListState<DealerContact>{
    editModel:DealerContact;
    dealer: number;
    
}
class DealerContactModule extends ListModule<DealerContactState,any,DealerContact>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<DealerContact>(),
        loading:false,
        dealer: null,
        editModel: new DealerContact(),
        activeList: new Array<DealerContact>(),
        path: 'dealer-contacts'          
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions    
        async getAll(context: ActionContext<DealerContactState, any>, payload: any) {
            if (context.state.loading) return context.state.list;
            context.state.loading = true;
            payload.data.dealer = context.state.dealer;
            let reponse = await Ajax.get('/api/' + (context.state as any).path, { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            if (typeof reponse.data.result == 'object' && !Array.isArray(reponse.data.result)) {
                let page = reponse.data.result as PageResult<DealerContact>;
                context.state.totalCount = page.total;
                context.state.list = page.data;
            } else {
                context.state.totalCount = reponse.data.result.length;
                context.state.list = reponse.data.result;
            }
            return context.state.list;
        },
        async create(context: ActionContext<DealerContactState, any>, payload: any) {
            context.state.loading = true;
            payload.data.dealer_id = context.state.dealer;
            let response = await Ajax.post('/api/' + (context.state as any).path, payload.data).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            if (response.data.result && (context.state as any).activeList != undefined)
                (context.state as any).activeList.push(response.data.result);
            return response.data.result;
        },
        async update(context: ActionContext<DealerContactState, any>, payload: any) {
            context.state.loading = true;
            payload.data.dealer_id = context.state.dealer;
            let response = await Ajax.put('/api/' + (context.state as any).path + '/' + payload.data.id, payload.data).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            if ((context.state as any).activeList != undefined) {
                (context.state as any).activeList.forEach((item, k) => {
                    if (item.id == payload.data.id)
                        (context.state as any).activeList[k] = Util.extend((context.state as any).activeList[k], payload.data);
                });
            }
            return response.data.result;
        },
        async delete(context: ActionContext<DealerContactState, any>, payload: any) {
            context.state.loading = true;
            let id = payload.data.id;
            await Ajax.delete('/api/' + (context.state as any).path + '/' + id).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            //context.state.list.slice
        },
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
        setDealer(state: DealerContactState, dealer: number) {
            state.dealer = dealer;
        }
    });
}
const dealercontactModule=new DealerContactModule();
export default dealercontactModule;
